function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var p = ["top", "right", "bottom", "left"],
  l = ["start", "end"],
  j = p.reduce(function (t, e) {
    return t.concat(e, e + "-" + l[0], e + "-" + l[1]);
  }, []),
  C = Math.min,
  L = Math.max,
  E = Math.round,
  R = Math.floor,
  T = function T(t) {
    return {
      x: t,
      y: t
    };
  },
  h = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  },
  x = {
    start: "end",
    end: "start"
  };
function k(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function g(t) {
  return t.split("-")[0];
}
function m(t) {
  return t.split("-")[1];
}
function b(t) {
  return t === "x" ? "y" : "x";
}
function d(t) {
  return t === "y" ? "height" : "width";
}
var A = new Set(["top", "bottom"]);
function P(t) {
  return A.has(g(t)) ? "y" : "x";
}
function y(t) {
  return b(P(t));
}
function q(t, e, n) {
  n === void 0 && (n = !1);
  var r = m(t),
    i = y(t),
    o = d(i);
  var c = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[o] > e.floating[o] && (c = f(c)), [c, f(c)];
}
function z(t) {
  var e = f(t);
  return [s(t), e, s(e)];
}
function s(t) {
  return t.replace(/start|end/g, function (e) {
    return x[e];
  });
}
var u = ["left", "right"],
  a = ["right", "left"],
  M = ["top", "bottom"],
  O = ["bottom", "top"];
function S(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? a : u : e ? u : a;
    case "left":
    case "right":
      return e ? M : O;
    default:
      return [];
  }
}
function B(t, e, n, r) {
  var i = m(t);
  var o = S(g(t), n === "start", r);
  return i && (o = o.map(function (c) {
    return c + "-" + i;
  }), e && (o = o.concat(o.map(s)))), o;
}
function f(t) {
  return t.replace(/left|right|bottom|top/g, function (e) {
    return h[e];
  });
}
function w(t) {
  return _objectSpread({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, t);
}
function D(t) {
  return typeof t != "number" ? w(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function F(t) {
  var e = t.x,
    n = t.y,
    r = t.width,
    i = t.height;
  return {
    width: r,
    height: i,
    top: n,
    left: e,
    right: e + r,
    bottom: n + i,
    x: e,
    y: n
  };
}
export { l as alignments, T as createCoords, k as evaluate, w as expandPaddingObject, R as floor, m as getAlignment, y as getAlignmentAxis, q as getAlignmentSides, d as getAxisLength, z as getExpandedPlacements, s as getOppositeAlignmentPlacement, b as getOppositeAxis, B as getOppositeAxisPlacements, f as getOppositePlacement, D as getPaddingObject, g as getSide, P as getSideAxis, L as max, C as min, j as placements, F as rectToClientRect, E as round, p as sides };